export interface Sport {
  id: string
  name: string
  slug: string
  category: SportCategory
}

export enum SportCategory {
  BALLSPORT = 'BALLSPORT',
  FITNESS = 'FITNESS',
  FUNSPORT = 'FUNSPORT',
}

export interface City {
  id: string
  name: string
  slug: string
  canonicalHost: string
}

export interface Image {
  xSmall?: string
  small?: string
  medium?: string
  large?: string
}

interface SocialInterface {
  type: string
  siteName: string
  title: string
  description?: string
  url: string
  image: Image
}

interface Social {
  openGraph: SocialInterface
  twitter: Pick<SocialInterface, 'type' | 'title' | 'description' | 'image'>
}

export interface Meta {
  title: string
  description?: string
  social: Social
}

export interface Tag {
  name: string
}

export interface Review {
  id: string
  comment?: string
}

export interface Venue {
  id: string
  name: string
  profileImage?: { small: string; medium: string }
  slug: string
  rating?: number
  reviewCount: number
  sports: Array<Sport>
  tags: Array<Tag>
  address: string
  cheapestPrice: MonetaryValue | undefined
}

export enum DiscoverOfferingType {
  DISCOVER_OFFERING_CAMP_ACTIVITY = 'DISCOVER_OFFERING_CAMP_ACTIVITY',
  DISCOVER_OFFERING_CLASS_ACTIVITY = 'DISCOVER_OFFERING_CLASS_ACTIVITY',
  DISCOVER_OFFERING_COURSE_ACTIVITY = 'DISCOVER_OFFERING_COURSE_ACTIVITY',
  DISCOVER_OFFERING_EDUCATION_ACTIVITY = 'DISCOVER_OFFERING_EDUCATION_ACTIVITY',
  DISCOVER_OFFERING_EVENT_ACTIVITY = 'DISCOVER_OFFERING_EVENT_ACTIVITY',
  DISCOVER_OFFERING_LIVESTREAM = 'DISCOVER_OFFERING_LIVESTREAM',
  DISCOVER_OFFERING_OPENTRAINING_ACTIVITY = 'DISCOVER_OFFERING_OPENTRAINING_ACTIVITY',
  DISCOVER_OFFERING_PUBLIC_MATCH = 'DISCOVER_OFFERING_PUBLIC_MATCH',
  DISCOVER_OFFERING_RETREAT_ACTIVITY = 'DISCOVER_OFFERING_RETREAT_ACTIVITY',
  DISCOVER_OFFERING_TRAINING_ACTIVITY = 'DISCOVER_OFFERING_TRAINING_ACTIVITY',
  DISCOVER_OFFERING_VIDEO = 'DISCOVER_OFFERING_VIDEO',
  DISCOVER_OFFERING_WORKSHOP_ACTIVITY = 'DISCOVER_OFFERING_WORKSHOP_ACTIVITY',
}

export enum DiscoverPrefix {
  CLASSES = '/dcl',
  TRAININGS = '/dtr',
  COURSES = '/dco',
  WORKSHOPS = '/dwo',
  EVENTS = '/dev',
  RETREATS = '/dre',
  EDUCATION = '/ded',
  CAMPS = '/dca',
  OPEN_TRAININGS = '/dotr',
  LIVESTREAMS = '/doc/online-classes',
  VIDEOS = '/discover/videos',
  PUBLIC_MATCHES = '/matches',
}

export interface MonetaryValue {
  currency: string
  value: number
}

export enum ShowType {
  FILTERS = 'filters',
  MAP = 'map',
  SEARCH = 'search',
  CALENDAR = 'calendar',
}

export interface Results<T> {
  shownResults: Array<T>
  count: number
}

export enum EventDifficultyLevel {
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  PROFESSIONAL = 'PROFESSIONAL',
  ALL = 'ALL',
}

export enum EventType {
  CAMP = 'Camp',
  CLASS = 'Class',
  COURSE = 'Course',
  EDUCATION = 'Education',
  EVENT = 'Event',
  OPENTRAINING = 'OpenTraining',
  RETREAT = 'Retreat',
  TRAINING = 'Training',
  WORKSHOP = 'Workshop',
}

export interface Location {
  detail: string
  street: string
  city: string
  zip: string
}

export interface LimitedSpots {
  __typename: 'LimitedSpots'
  type: string
  displayCapped: boolean
  limit: number
}

export interface UnlimitedSpots {
  __typename: 'UnlimitedSpots'
  type: string
}

export interface EventSession {
  id: string
  image?: Image | null
  name: string
  start: string
  end: string
  hasOnlineStream: boolean
}
